import React, {Component, PropTypes} from 'react';
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import {
  Link,
  LinkIcon,
  PlanScorecardResultModal,
  XsBr
} from '../../components'
import Styles from './PlanScorecardDefaultScorecard.css'

@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardDefaultScorecard extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      currDefaultFund: props.fund,
      notPlan: props.notPlan || false
    }
  }

  render() {
    const { currDefaultFund, notPlan } = this.state
    if (!currDefaultFund) {
      this.context.router.push(config.routes.plans)
      return (
        <div styleName='page'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    //
    const fffIcon = require( '../../../static/images/icons/fff-icon.svg' )
    const ffbIcon = require( '../../../static/images/icons/ffb-icon.svg' )
    const ffiIcon = require( '../../../static/images/icons/ffi-icon.svg' )
    const dffIcon = require( '../../../static/images/icons/dff-icon.svg' )
    const gefIcon = require( '../../../static/images/icons/gef-icon.svg' )
    const gffIcon = require( '../../../static/images/icons/gff-icon.svg' )
    const pffIcon = require( '../../../static/images/icons/pff-icon.svg' )
    const wffIcon = require( '../../../static/images/icons/wff-icon.svg' )
    const tffIcon = require( '../../../static/images/icons/tff-icon.svg' )
    //

    const redOctagon = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Poor' styleName='red-octagon'/>
        </div>
        <div styleName='result-val result-val-poor'>
          Poor
        </div>
      </div>
    )
    const yellowSquare = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Fair' styleName='yellow-square'/>
        </div>
        <div styleName='result-val result-val-fair'>
          Fair
        </div>
      </div>
    )
    const greenCircle = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Good' styleName='green-circle'/>
        </div>
        <div styleName='result-val result-val-good'>
          Good
        </div>
      </div>
    )

    const shapeDecider = (fund, grade_label) => {
      const grade = fund[grade_label]
      if (grade >= 4) {
        return redOctagon
      } else if (grade >= 2) {
        return yellowSquare
      } else if (grade === 1) {
        return greenCircle
      }
      return null
    }
    //
    return (
      <div styleName='snapshot-results'>
        { /* HEADER 1 */ }
        <Row>
          <Col xs={12} sm={12} md={6}>
            <div styleName='scorecard-shadow'>
              <h3 styleName='th-e'>
                <b>Environment</b> <XsBr/>scorecard
              </h3>
              <div styleName='result-card-wrap-row'>
                <PlanScorecardResultModal iyv='fff' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={fffIcon} alt='Fossil fuels' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Fossil fuels</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_fossil') }
                    </div>
                  </div>
                </PlanScorecardResultModal>

                {/* WORKING HERE */}
                <PlanScorecardResultModal iyv='ffb' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap result-card-small'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={ffbIcon} alt='Fossil fuel finance' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Fossil fuel finance</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_fossil_bank') }
                    </div>
                  </div>
                </PlanScorecardResultModal>
                <PlanScorecardResultModal iyv='ffi' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap result-card-small'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={ffiIcon} alt='Fossil fuel insurance' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Fossil fuel insurance</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_fossil_insure') }
                    </div>
                  </div>
                </PlanScorecardResultModal>

                <PlanScorecardResultModal iyv='dff' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={dffIcon} alt='Deforestation' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Deforestation</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_deforestation') }
                    </div>
                  </div>
                </PlanScorecardResultModal>
              </div>
            </div>
            <div styleName='hidden-xs hidden-sm'>
              { /* <p styleName='methodology-sentence'>
                We used our expertise in mutual fund sustainability
                analysis and extensive database of ESG-screened
                companies to rate corporations’ retirement plan
                investment options.
              </p> */ }
              <div styleName='scorecard-methodology-link'>
                <Link
                  to={config.routes.howitworks}
                  title='How it works'
                  transparentbutton
                >
                  Methodology<LinkIcon />
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={12} md={6}>
            <div styleName='scorecard-shadow'>
              <h3 styleName='th-s'>
                <b>Social</b> <XsBr/>scorecard
              </h3>
              <div styleName='result-card-wrap-row'>
                { /*
                <PlanScorecardResultModal iyv='gef' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={gefIcon} alt='Gender equality' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Gender equality</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_gender_equality') }
                    </div>
                  </div>
                </PlanScorecardResultModal>
                */ }
                <PlanScorecardResultModal iyv='gff' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={gffIcon} alt='Civilian firearms' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Civilian firearms</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_guns') }
                    </div>
                  </div>
                </PlanScorecardResultModal>
                <PlanScorecardResultModal iyv='pff' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={pffIcon} alt='Prison industrial complex' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Prison industrial complex</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_prison_industrial_complex') }
                    </div>
                  </div>
                </PlanScorecardResultModal>
                <PlanScorecardResultModal iyv='wff' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={wffIcon} alt='Military weapons' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Military weapons</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_military') }
                    </div>
                  </div>
                </PlanScorecardResultModal>
                <PlanScorecardResultModal iyv='tff' fund={currDefaultFund} notPlan={notPlan}>
                  <div styleName='result-card-wrap'>
                    <div styleName='result-card'>
                      <div styleName='result-lbl-icon-bbl'>
                        <img styleName='result-lbl-icon' src={tffIcon} alt='Tobacco' />
                      </div>
                      <div styleName='result-lbl'>
                        <span styleName='result-lbl-txt'>Tobacco</span>
                      </div>
                      { shapeDecider(currDefaultFund, 'grade_tobacco') }
                    </div>
                  </div>
                </PlanScorecardResultModal>
              </div>
            </div>
          </Col>
        </Row>
        <div styleName='hidden-md hidden-lg'>
          { /* <p styleName='methodology-sentence'>
            We used our expertise in mutual fund sustainability
            analysis and extensive database of ESG-screened
            companies to rate corporations’ retirement plan
            investment options.
          </p> */ }
          <div styleName='scorecard-methodology-link'>
            <Link
              to={config.routes.howitworks}
              title='How it works'
              transparentbutton
            >
              Methodology<LinkIcon />
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
